function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHexagonFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073C7A",
      stroke: "#073C7A",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8,1.3339844 2.2226562,4.671875 v 6.65625 L 8,14.666016 13.777344,11.328125 v -6.65625 z",
    transform: "scale(1.5)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHexagonFilled);
export default __webpack_public_path__ + "static/media/icon_hexagon_filled.ef0cc9c1843b70a168163e9015f97b43.svg";
export { ForwardRef as ReactComponent };